export const UPDATE_BOT_BUILDER_STATE = 'UPDATE_BOT_BUILDER_STATE';
export const DELETE_BOT_BUILDER_STATE = 'DELETE_BOT_BUILDER_STATE';
export const PREEMPTIVE_DATA_LOADED = 'PREEMPTIVE_DATA_LOADED';
export const WORK_FLOW_LOADING = 'WORK_FLOW_LOADING';
export const WORK_FLOW_LOADED = 'WORK_FLOW_LOADED';
export const WORK_FLOW_ERROR = 'WORK_FLOW_ERROR';
export const WORK_FLOW_DELETED = 'WORK_FLOW_DELETED';
export const WORK_FLOW_UPDATED = 'WORK_FLOW_UPDATED';
export const WORK_FLOW_CREATED = 'WORK_FLOW_CREATED';
export const WORK_FLOW_MODEL_LOADING = 'WORK_FLOW_MODEL_LOADING';
export const WORK_FLOW_MODEL_LOADED = 'WORK_FLOW_MODEL_LOADED';
export const WORK_FLOW_MODEL_ERROR = 'WORK_FLOW_MODEL_ERROR';
export const RESET_WORK_FLOW_MODEL = 'RESET_WORK_FLOW_MODEL';
export const UPDATE_WORK_FLOW_MODEL = 'UPDATE_WORK_FLOW_MODEL';
export const WORK_FLOW_DIAGRAM_SAVED = 'WORK_FLOW_DIAGRAM_SAVED';
export const WORK_FLOW_NODE_DETAILS_LOADED = 'WORK_FLOW_NODE_DETAILS_LOADED';
export const CLEAR_WORK_FLOW_NODE_DETAILS = 'CLEAR_WORK_FLOW_NODE_DETAILS';
export const WORKFLOW_DIAGRAM_NODE_CHANGING = 'WORKFLOW_DIAGRAM_NODE_CHANGING';
export const WORKFLOW_TYPE_NODE_CREATED = 'WORKFLOW_TYPE_NODE_CREATED';
export const WORKFLOW_TYPE_NODE_UPDATED = 'WORKFLOW_TYPE_NODE_UPDATED';
export const ENTITY_TYPE_NODE_CREATED = 'ENTITY_TYPE_NODE_CREATED';
export const ENTITY_TYPE_NODE_UPDATED = 'ENTITY_TYPE_NODE_UPDATED';
export const WORKFLOW_DIAGRAM_NODE_ERROR = 'WORKFLOW_DIAGRAM_NODE_ERROR';



// WEBPACK FOOTER //
// ./src/data/redux/botbuilder_details/actiontypes.js